<!-- Hero Section -->
<div
  class="w-full flex justify-center items-center bg-cover bg-center bg-no-repeat bg-[url('/assets/images/Group_69.webp')] min-h-[40vh] sm:h-[300px] relative px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div class="absolute inset-0 bg-black opacity-80"></div>
  <div class="text-center z-40 relative container mx-auto">
    <h1
      class="text-2xl sm:text:3xl lg:text-4xl font-extrabold text-center text-white"
    >
      Ready to Part with Your Tesla?
    </h1>
    <p class="sm:text-xl max-w-3xl mx-auto text-white mt-4">
      Connect with passionate Tesla enthusiasts and get the best value for your
      vehicle on the largest marketplace for pre-owned Teslas.
    </p>
  </div>
</div>

<main class="bg-gradient-to-b from-gray-50 to-white px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div class="container mx-auto px-4 py-16 sm:px-6 sm:py-24">
    <!-- Main Content -->
    <div class="grid gap-12 lg:grid-cols-3">
      <!-- Left Column - Main Content -->
      <div class="lg:col-span-2">
        <div class="prose prose-lg">
          <div class="text-gray-600 flex flex-col gap-y-2">
            <p>
              Have you been thinking about selling your Tesla? You've come to
              the right place! Here at Only Used Tesla, we connect passionate
              Tesla owners like you with eager buyers every day.
            </p>
            <p>
              But before you can start, there's one important step: registering
              and logging in. By creating an account, you're not just posting a
              listing — you're becoming part of our network of Tesla
              enthusiasts. It's free, secure, and gives you access to exclusive
              features that will help you get the best deal for your vehicle.
            </p>
          </div>

          <div class="bg-white p-8 rounded-2xl shadow-sm mt-8">
            <h2 class="text-2xl text-gray-900 font-semibold mb-6">
              What You'll Get
            </h2>

            <div class="flex flex-col gap-y-6">
              <!-- Feature Cards -->
              <div class="flex items-start gap-x-4">
                <div class="flex-shrink-0">
                  <svg
                    class="h-6 text-blue-500 w-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 class="text-gray-900 font-semibold">Create a Listing</h3>
                  <p class="text-gray-600">
                    Showcase your Tesla's unique features, upload high-quality
                    photos, and set your price.
                  </p>
                </div>
              </div>

              <div class="flex items-start gap-x-4">
                <div class="flex-shrink-0">
                  <svg
                    class="h-6 text-blue-500 w-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 class="text-gray-900 font-semibold">
                    Connect with Buyers
                  </h3>
                  <p class="text-gray-600">
                    Interact with interested buyers from our community. Discuss
                    details and negotiate securely.
                  </p>
                </div>
              </div>

              <div class="flex items-start gap-x-4">
                <div class="flex-shrink-0">
                  <svg
                    class="h-6 text-blue-500 w-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 class="text-gray-900 font-semibold">Market Insights</h3>
                  <p class="text-gray-600">
                    Access our database of Tesla sales to price competitively
                    and understand the market.
                  </p>
                </div>
              </div>

              <div class="flex items-start gap-x-4">
                <div class="flex-shrink-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 14 14"
                    class="size-6 text-blue-500"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M3 7V4.37A3.93 3.93 0 0 1 7 .5a3.93 3.93 0 0 1 4 3.87V7M1.5 5.5h1A.5.5 0 0 1 3 6v3a.5.5 0 0 1-.5.5h-1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1m11 4h-1A.5.5 0 0 1 11 9V6a.5.5 0 0 1 .5-.5h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1M9 12.25a2 2 0 0 0 2-2V8m-2 4.25a1.25 1.25 0 0 1-1.25 1.25h-1.5a1.25 1.25 0 0 1 0-2.5h1.5A1.25 1.25 0 0 1 9 12.25"
                      stroke-width="1"
                    />
                  </svg>
                </div>
                <div>
                  <h3 class="text-gray-900 font-semibold">Receive Support</h3>
                  <p class="text-gray-600">
                    Our dedicated customer service team is available to assist
                    you throughout the selling process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CTA Section -->
        <div class="bg-blue-600 p-8 rounded-2xl text-white mt-8">
          <h2 class="text-2xl font-semibold mb-4">Ready to Get Started?</h2>
          <p class="mb-6">
            Join our community of Tesla enthusiasts and start your selling
            journey today.
          </p>
          <button
            (click)="Login()"
            class="bg-white border border-transparent rounded-full shadow-sm text-base text-blue-600 duration-200 hover:bg-transparent hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-blue-600 focus:ring-white font-medium hover:bg-gray-50 inline-flex items-center px-6 py-3 transition-all cursor-pointer"
          >
            Register or Log In
            <svg
              class="h-5 w-5 -mr-1 ml-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </button>
        </div>
      </div>

      <!-- Right Column - Support Card -->
      <div class="lg:col-span-1">
        <div class="bg-white p-8 rounded-2xl shadow-sm sticky top-8">
          <h3 class="text-gray-900 text-xl font-semibold mb-4">
            Need Support?
          </h3>
          <p class="text-gray-600 mb-6">
            Our dedicated customer service team is here to help you throughout
            the selling process.
          </p>
          <span
            routerLink="/contact"
            class="text-blue-600 hover:text-blue-500 inline-flex items-center"
          >
            <svg
              class="h-5 w-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            Contact Support
          </span>
        </div>
      </div>
    </div>
  </div>
</main>
